@if (pending) {
  <mat-progress-bar mode="indeterminate" class="absolute-top"></mat-progress-bar>
}
<h2 mat-dialog-title>{{'CURRENT_OFFERS.PAYMENT.INFOS.UPDATE.TITLE' | translate}}</h2>
<mat-dialog-content>
  <p>{{'CURRENT_OFFERS.PAYMENT.INFOS.UPDATE.MESSAGE' | translate}}</p>
  @if (this.error) {
    <p class="error">{{'CURRENT_OFFERS.PAYMENT.INFOS.UPDATE.ERROR' | translate}}</p>
  }
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.NAME.LABEL' | translate}}</mat-label>
      <input cdkFocusInitial matInput formControlName="name" required autocomplete="off">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.PHONE.LABEL' | translate}}</mat-label>
      <input matInput formControlName="phone" autocomplete="off">
    </mat-form-field>
    <ng-container formGroupName="address">
      <mat-form-field appearance="outline">
        <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.ADDRESS1.LABEL' | translate}}</mat-label>
        <input matInput formControlName="line1" required autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.ADDRESS2.LABEL' | translate}}</mat-label>
        <input matInput formControlName="line2" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.POSTALCODE.LABEL' | translate}}</mat-label>
        <input matInput formControlName="postal_code" required autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.CITY.LABEL' | translate}}</mat-label>
        <input matInput formControlName="city" required autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.STATE.LABEL' | translate}}</mat-label>
        <input matInput formControlName="state" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'CURRENT_OFFERS.PAYMENT.INFOS.COUNTRY.LABEL' | translate}}</mat-label>
        <input matInput formControlName="country" autocomplete="off">
      </mat-form-field>
    </ng-container>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="btn-uppercase align-right">
  <button mat-button color="primary" [disabled]="form.disabled" [mat-dialog-close]="null">
    {{'COMMON.BUTTONS.CANCEL' | translate}}
  </button>
  <button mat-button color="primary" (click)="submit()" [disabled]="form.disabled || form.invalid">
    {{'COMMON.BUTTONS.SUBMIT' | translate}}
  </button>
</mat-dialog-actions>
